import { Fingerprint } from '@phosphor-icons/react';

export default Fingerprint;
